import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { Rubric } from '../../models/Accounting/Rubric';

const ACCOUNTING_HOST = process.env.REACT_APP_ACCOUNTING_HOST;
const ACCOUNTING_KEY = process.env.REACT_APP_ACCOUNTING_KEY;

export const GET_RUBRICS_REQUEST = 'ACCOUNTING_GET_RUBRICS_REQUEST';
export const GET_RUBRICS_RESPONSE = 'ACCOUNTING_GET_RUBRICS_RESPONSE';
export const GET_RUBRICS_ERROR = 'ACCOUNTING_GET_RUBRICS_ERROR';

export const GET_TEMPLATES_REQUEST = 'ACCOUNTING_GET_TEMPLATES_REQUEST';
export const GET_TEMPLATES_RESPONSE = 'ACCOUNTING_GET_TEMPLATES_RESPONSE';
export const GET_TEMPLATES_ERROR = 'ACCOUNTING_GET_TEMPLATES_ERROR';

export const SET_RUBRIC = 'ACCOUNTING_SET_RUBRIC';

export const getRubricsAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_RUBRICS_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/rubrics`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_RUBRICS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_RUBRICS_ERROR,
            error,
        });
    }
};

export const getTemplatesAction = (rubricId: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_TEMPLATES_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/templates?rubric_id=${rubricId}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_TEMPLATES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_TEMPLATES_ERROR,
            error,
        });
    }
};

export const setRubricAction = (rubric: Rubric) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_RUBRIC,
        rubric,
    });
};



// WEBPACK FOOTER //
// ./src/actions/Accounting/accounting.ts